export default __webpack_public_path__ + "static/media/mail-enable.c3643922.svg";